import { graphql } from '@graphql/__generated'

export const TRIGGER_MEMBERSHIP_EMAIL = graphql(`
  mutation triggerMembershipEmail($orgName: String!, $template: String!) {
    triggerMembershipEmail(orgName: $orgName, emailTemplate: $template)
  }
`)
